import * as api from '../api';
import { RECEIVE_CATEGORIES } from '../constants/action-types';

export const getCategories = () => dispatch => {
  api.getPrimaryCategories().then(categories => {
      dispatch(receiveCategories(categories));
      return categories;
  })
}

export const receiveCategories = categories => ({
  type: RECEIVE_CATEGORIES,
  categories
});